import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OfflinePinIcon(props: IconProps) {
    return <Icon {...props} iconKey={"offline_pin"}/>
}
